import React from "react";

import NumberFormat from "react-number-format";

import CstmTextField from "./CstmTextField";

const MoneyTextField = (props) => {
  const { field } = props;

  return (
    <React.Fragment>
      <CstmTextField
        {...props}
        InputProps={{
          inputComponent: NumberFormatCustom,
        }}
        inputProps={{
          name: field.name,
          value: field.value,
        }}
      />
    </React.Fragment>
  );
};

const NumberFormatCustom = (props) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix="$"
    />
  );
};

export default MoneyTextField;



// WEBPACK FOOTER //
// ./src/components/MoneyTextField.js